import React from 'react';
import { Channel, useChatContext, MessageTeam } from 'stream-chat-react';
import { ChannelInner, CreateChannel, EditChannel } from './';
import ChannelListContainer from './ChannelListContainer';

const ChannelContainer = ({ isCreating, setIsCreating, isEditing, setIsEditing, createType }) => {

  const { channel } = useChatContext(); //will give us info about the current specific channel
  
  if(isCreating){ //if no such channel is there, create it 
    return(
            <div className="channel__container">
                <CreateChannel createType={createType} setIsCreating={setIsCreating} />
            </div>
    )
  }

  if(isEditing){ //for editing the existing channel
    return(
            <div className="channel__container">
                <EditChannel setIsEditing={setIsEditing} />
            </div> 
    )
  }

  const EmptyState = () => ( //Channel having no messages
    <div className="channel-empty__container">
        <p className="channel-empty__first">This is the beginning of your chat history.</p>
        <p className="channel-empty__second">Send messages, attachments, links, emojis, and more!</p>
    </div>
)
  
  return (
    <div className='channel__container'>
        <Channel 
            EmptyStateIndicator={EmptyState}
            Message={(messageProps, i) => <MessageTeam key={i} {...messageProps} />}
            > {/* This MessageTeam will display all the msgs that our users sent */}
          <ChannelInner setIsEditing={setIsEditing} /> {/* If we click on the button next to channel name-this line will take us to editchannel comp */}
        </Channel>
    </div>
  );
};

export default ChannelContainer;
